import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Container from 'components/Container';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Sidebar from 'components/Sidebar';

import { getGpt, updateGpt } from 'api/gpts';
import SelectInput from 'components/Form/SelectInput';
import TextInput from 'components/Form/TextInput';

export default function Edit() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const { gptId } = useParams();
    const cache = useQueryClient();
    const navigate = useNavigate();

    const { data: gpt } = useQuery({
        queryKey: ['gpts', gptId],
        queryFn: async () => await getGpt({ id: gptId }),
        enabled: Boolean(gptId),
    });

    const { mutate } = useMutation({
        mutationKey: ['updateGpt'],
        mutationFn: updateGpt,
        onSuccess: (data) => {
            cache.invalidateQueries(['gpts']);
            return navigate(`/settings/gpts/${data._id}`);
        },
        onError: (error) => {
            console.error("Error updating gpt:", error);
        }
    });



    function onSubmitHandler(formData) {
        const data = {
            name: formData.get('name'),
            slug: formData.get('slug'),
            apiKey: formData.get('apiKey'),
            url: formData.get('url'),
            enabled: formData.get('enabled') === 'true',
            public: formData.get('public') === 'true',
            type: formData.get('type'),
        }
        mutate({ id: gptId, data });
    }

    if (!gpt) {
        return <></>;
    }

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] overflow-scroll ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container className='!min-w-[700px] !max-w-[700px]'>
                    <div className='pb-8 pt-20 md:pt-14 text-center'>
                        <p className='text-3xl'>{gpt.name}</p>
                    </div>

                    <div className='pb-20'>
                        <form action={onSubmitHandler} className='flex flex-col gap-4'>
                            <TextInput
                                label="Nome"
                                name="name"
                                placeholder="Nome"
                                defaultValue={gpt.name}
                            />

                            <TextInput
                                label="Slug"
                                name="slug"
                                placeholder="Slug"
                                className="mt-4"
                                defaultValue={gpt.slug}
                            />

                            <TextInput
                                label="API Key"
                                type="password"
                                name="apiKey"
                                className="mt-4"
                                defaultValue={gpt.apiKey}
                            />

                            <TextInput
                                label="URL"
                                type="text"
                                name="url"
                                className="mt-4"
                                defaultValue={gpt.url}
                            />

                            <SelectInput
                                label="Abilitato"
                                name="enabled"
                                options={[
                                    { value: 'true', label: 'Sì' },
                                    { value: 'false', label: 'No' }
                                ]}
                                className="mt-4"
                                defaultValue={gpt.enabled}
                            />
                            <SelectInput
                                label="Pubblico"
                                name="public"
                                options={[
                                    { value: 'true', label: 'Sì' },
                                    { value: 'false', label: 'No' }
                                ]}
                                className="mt-4"
                                defaultValue={gpt.public}
                            />
                            <SelectInput
                                label="Tipologia"
                                name="type"
                                options={[
                                    { value: 'model', label: 'Model' },
                                    { value: 'embedding', label: 'Embedding' }
                                ]}
                                className="mt-4"
                                defaultValue={gpt.type}
                            />

                            <div className='flex justify-end'>
                                <button type="submit" className='mt-6 bg-black hover:bg-greydark text-white text-sm font-medium px-6 py-3 rounded-md transition-colors cursor-pointer duration-200'>Salva</button>
                            </div>
                        </form>
                    </div>
                </Container>
            </div>

        </>
    )
}
